/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { Image, Card, Container, Row, Col } from "react-bootstrap";

export interface IFeaturesProps {
  featureTitle?: string;
  featureDescription?: string;
  features?: {
    title: string;
    description?: string;
    icon: string | any;
  }[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

const Feature = (props) => {
  const { title, description, icon } = props;

  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === "string") {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={184}
            height={142}
            className={"text-gray-500 mb-3"}
          />
        );
      } else {
        const HeroIcon = require("@heroicons/react/solid");
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className={"icon icon-md text-gray-500 mb-3"}
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon
          key={`hero-icon-2`}
          className={"icon icon-md text-gray-500 mb-3"}
        />
      );
    }
    return _icon;
  };

  return (
    <Col xs={12} sm={4} lg={4}>
      <div className="px-3 px-lg-4 py-5 text-center">
        {_getIcon(icon)}
        {title && <h5 className="fw-bold text-primary">{title}</h5>}
        {description && <p>{description}</p>}
      </div>
    </Col>
  );
};

export const Features = ({
  featureTitle,
  featureDescription,
  features,
}: IFeaturesProps) => {
  if (featureTitle) {
    return (
      <section className="section bg-white section-lg">
        <Container>
          <Row className="justify-content-center mb-5 mb-lg-6">
            <Col xs={12} className="text-center">
              {featureTitle && <h2 className="px-lg-5">{featureTitle}</h2>}
              {featureDescription && (
                <p className="lead px-lg-8">{featureDescription}</p>
              )}
            </Col>
          </Row>
          <Row>
            {features?.map((feature, index) => (
              <Feature key={`features-${index}`} {...feature} />
            ))}
          </Row>
        </Container>
      </section>
    );
  }
  return null;
};

Features.defaultProps = {};
